export const MuiOutlinedInputStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "1rem",
  },
  "& .MuiSelect-select": {
    pt: "18px",
    pb: "12px",
    display: "flex", // NOTE: Ajuste na exibicao apos selecao
    alignItems: "center",
  },
};

export const MuiSelectIconStyles = {
  "& .MuiSelect-icon": {
    fontSize: "1.2rem",
    right: "14px", // Ajuste de distância da borda direita
    transition: "transform 0.2s ease-in-out", // Suaviza a rotação
  },
};
